// extracted by mini-css-extract-plugin
export default {"formAvatar":"Profile_formAvatar__XP+xv"};